import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { AccordionItem } from 'components/atoms/Accordion';

import './accordion.scss';

const DEFAULT_CONTENT = [];

export function Accordion({
	className,
	content = DEFAULT_CONTENT,
	faqSchema,
	isFAQ,
	preserve = false,
	type,
	iconType,
}) {
	return (
		<div className={classnames(className, 'accordion')}>
			<div>
				{content.map(({ question, answer, link, expanded }) => (
					<AccordionItem
						question={question}
						answer={answer}
						link={link}
						key={question}
						isFAQ={isFAQ}
						preserve={preserve}
						type={type}
						iconType={iconType}
						defaultExpanded={expanded}
					/>
				))}
			</div>
			{!isEmpty(faqSchema) && (
				<script
					key="schema"
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: faqSchema,
					}}
				/>
			)}
		</div>
	);
}

Accordion.propTypes = {
	className: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	faqSchema: PropTypes.string,
	isFAQ: PropTypes.bool,
	preserve: PropTypes.bool,
	type: PropTypes.string,
	iconType: PropTypes.string,
};

export default Accordion;
